import {api} from '@/../ui-domain';

export type ValidateCodeScene = 'LOGIN';

export function getValidateCodeUrl(scene: ValidateCodeScene, uuid: string) {
  return `${api.base}/captchas/${uuid}/${scene}?rmd=${new Date().getTime()}`;
}
